import React from "react";

/**
 * FlowFinder brand mark — uses the generated camo-F-shield logo.
 * Pass `size` (px) and optionally `withWordmark` to render the text next to it.
 */
export default function BrandMark({ size = 36, withWordmark = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span
        className="relative inline-flex items-center justify-center rounded-xl overflow-hidden border border-white/10 bg-white/[0.04] backdrop-blur-xl shrink-0"
        style={{ width: size, height: size }}
      >
        <img
          src="/logo192.png"
          alt="FlowFinder"
          className="block"
          style={{ width: size, height: size, objectFit: "contain" }}
          draggable={false}
        />
      </span>
      {withWordmark && (
        <span className="leading-none">
          <span className="text-[15px] font-semibold tracking-tight text-white">
            Flow<span className="text-white/60 font-normal">Finder</span>
          </span>
        </span>
      )}
    </span>
  );
}
